import { getClass } from '../get-class';
import { hasClass } from '../has-class';

export function addClass(element: Element, className: string) {
	if (element && !hasClass(element, className)) {
		element.setAttribute('class', getClass(element).trim() + ' ' + className);
	}
}
